function getClientPseudoUniqueId() {
  return `${String(Math.random())}-${String(new Date().getTime())}`;
}

export const clientId = getClientPseudoUniqueId();

export const aggregationSeparator = <const>'---';

export const defaultSearchType = <const>'arret';
export const defaultSearchSort = <const>'relevance';

export const defaultPaginationSize = 5;

// query 'CA Paris' shows the advice 'CA Paris' which replace the query by 'CA'
// so we need to allow less than the theoretical minimal (2)
export const minimalQueryLength = 1;

export const SEARCH_TYPES = <const>[
  'arret',
  'commentary',
  'law',
  'lawyer',
  'enterprise',
];

export const FACETS_TYPES = <const>[
  'juridiction',
  'domaine',
  'publi',
  'solution',
  'publisher',
  'ville',
  'textCode',
  'otherLegislation',
  'collectiveAgreements',
];
